var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseIcon = function SvgPauseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M2.625 2.571V21.43h3.5V2.57zM0 2.571C0 1.151 1.176 0 2.625 0h3.5C7.575 0 8.75 1.152 8.75 2.571V21.43C8.75 22.849 7.574 24 6.125 24h-3.5C1.175 24 0 22.848 0 21.429zm14.875 0V21.43h3.5V2.57zm-2.625 0C12.25 1.151 13.426 0 14.875 0h3.5C19.825 0 21 1.152 21 2.571V21.43C21 22.849 19.824 24 18.375 24h-3.5c-1.45 0-2.625-1.152-2.625-2.571z"
  })));
};
export default SvgPauseIcon;